export function getProvider() {
	if (!window.ethereum) return
	let provider
	if (window.ethereum.providers !== undefined) {
		provider = window.ethereum.providers.find(
			(provider) => provider.isMetaMask
		)
	} else {
		provider = window.ethereum
	}
	return provider
}
